export function applyKeyboardShortcut(target) {
  // div[contenteditable="true"] is Tiptap editor
  // span[contenteditable="true"] can be a highlight being edited
  return (
    ['TEXTAREA', 'INPUT'].indexOf(target.tagName) === -1 &&
    !target.matches('[contenteditable="true"]') &&
    target.closest('[contenteditable="true"]') === null
  )
}
